import data from './generated/watercolors.json';
import type { WorldMapModel, WorldMapRoad } from './worldMapModel';

export const watercolorAtlas = data;
export const watercolorArtworkUrl = `/assets/world-map/watercolors.svg?v=${data.artworkSha256.slice(0, 12)}`;

/** New topology uses the schematic until artwork and anchors are imported together. */
export function atlasMatchesModel(model: WorldMapModel): boolean {
  const ids = (values: string[]) => JSON.stringify(values.sort());
  const roads = (values: WorldMapRoad[]) => JSON.stringify(values.map(road => ({
    key: road.key, from: road.from, to: road.to, main: road.main,
    oneWay: road.oneWay, sealed: road.sealed, ferry: !!road.via,
  })).sort((a, b) => a.key.localeCompare(b.key)));
  const portals = (values: WorldMapModel['portalLinks']) => JSON.stringify((values ?? []).map(portal =>
    `${portal.from}/${portal.portalId}:${portal.to}:${!!portal.sealed}`).sort());
  return model.unplaced.length === 0
    && ids(model.places.map(place => place.id)) === ids(data.places.map(place => place.id))
    && roads(model.roads) === roads(data.modelRoads as WorldMapRoad[])
    && portals(model.portalLinks) === portals(data.modelPortalLinks);
}
